<app-branch-basic-info [isModal]="true">
</app-branch-basic-info>
